var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardProfitsEarned(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#FFF3EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2617 28.4375H22.2617",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7617 25.998V30.998",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.66 15.5181L25.63 15.5881L22.73 22.3181H19.88C19.2 22.3181 18.55 22.4581 17.96 22.7081L19.71 18.5281L19.75 18.4281L19.82 18.2681C19.84 18.2081 19.86 18.1481 19.89 18.0981C21.2 15.0681 22.68 14.3781 25.66 15.5181Z",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0505 22.5176C30.6005 22.3776 30.1205 22.3176 29.6405 22.3176H22.7305L25.6305 15.5876L25.6605 15.5176C25.8105 15.5676 25.9505 15.6376 26.1005 15.6976L28.3105 16.6276C29.5405 17.1376 30.4005 17.6676 30.9205 18.3076C31.0205 18.4276 31.1005 18.5376 31.1705 18.6676C31.2605 18.8076 31.3305 18.9476 31.3705 19.0976C31.4105 19.1876 31.4405 19.2776 31.4605 19.3576C31.7305 20.1976 31.5705 21.2276 31.0505 22.5176Z",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5217 27.1984V29.1484C34.5217 29.3484 34.5117 29.5484 34.5017 29.7484C34.3117 33.2384 32.3617 34.9984 28.6617 34.9984H20.8617C20.6217 34.9984 20.3817 34.9784 20.1517 34.9484C16.9717 34.7384 15.2717 33.0384 15.0617 29.8584C15.0317 29.6284 15.0117 29.3884 15.0117 29.1484V27.1984C15.0117 25.1884 16.2317 23.4584 17.9717 22.7084C18.5717 22.4584 19.2117 22.3184 19.8917 22.3184H29.6517C30.1417 22.3184 30.6217 22.3884 31.0617 22.5184C33.0517 23.1284 34.5217 24.9884 34.5217 27.1984Z",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.71 18.5273L17.96 22.7073C16.22 23.4573 15 25.1873 15 27.1973V24.2673C15 21.4273 17.02 19.0573 19.71 18.5273Z",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5186 24.2677V27.1977C34.5186 24.9977 33.0586 23.1277 31.0586 22.5277C31.5786 21.2277 31.7286 20.2077 31.4786 19.3577C31.4586 19.2677 31.4286 19.1777 31.3886 19.0977C33.2486 20.0577 34.5186 22.0277 34.5186 24.2677Z",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardProfitsEarned);
export default __webpack_public_path__ + "static/media/dashboard-profits-earned.50be48c2ca85ed10d77295edb3f8b393.svg";
export { ForwardRef as ReactComponent };